module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.fileItem) ? _c('v-btn-form', {
    attrs: {
      "mode": _vm.edit,
      "title": _vm.title
    },
    on: {
      "close": function($event) {
        return _vm.cancel()
      }
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function() {
        return [(!_vm.isEdit) ? _c('v-btn', {
          on: {
            "click": function($event) {
              return _vm.open(_vm.fileItem.uid)
            }
          }
        }, [_vm._v("Открыть")]) : _vm._e(), _vm._v(" "), (!_vm.isEdit) ? _c(_vm.createCopyButton('Ссылку', 'content_copy', 'Копировать ссылку', _vm.copyLink), {
          tag: "v-component"
        }) : _vm._e(), _vm._v(" "), (!_vm.isEdit) ? _c('v-spacer') : _vm._e(), _vm._v(" "), (!_vm.isEdit) ? _c('v-btn', {
          attrs: {
            "disabled": _vm.readonly || !_vm.historyItems || _vm.historyItems.length === 0 || _vm.historyItems[0].uid.localeCompare(_vm.fileItemId) !== 0
          },
          on: {
            "click": function($event) {
              _vm.edit = true
            }
          }
        }, [_vm._v("Атрибуты")]) : _vm._e(), _vm._v(" "), (_vm.isEdit) ? _c('v-btn', {
          on: {
            "click": _vm.save
          }
        }, [_vm._v("Сохранить")]) : _vm._e(), _vm._v(" "), (_vm.isEdit) ? _c('v-spacer') : _vm._e(), _vm._v(" "), (_vm.isEdit) ? _c('v-ops-btn', {
          attrs: {
            "cxt": _vm.cxt
          }
        }) : _vm._e()]
      },
      proxy: true
    }], null, false, 423556173)
  }, [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [(!_vm.isEdit) ? _c('v-flex', [_c('v-card-title', {
    staticStyle: {
      "display": "block",
      "overflow-wrap": "break-word"
    }
  }, [_c('div', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.fileItem.docName) + "\n          ")]), _vm._v(" "), _c(_vm.renderDepoFileSignature(_vm.fileItem), {
    tag: "v-component"
  })], 1), _vm._v(" "), _c('v-card-text', {
    staticStyle: {
      "display": "block",
      "overflow-wrap": "break-word"
    }
  }, [_c('v-flex', [_vm._v("\n          Cсылка: "), _c('b', [_c('a', {
    attrs: {
      "href": _vm.getUrl(_vm.fileItem.uid)
    }
  }, [_vm._v(_vm._s(_vm.getUrl(_vm.fileItem.uid)))])])]), _vm._v(" "), _c('v-flex', [_vm._v("\n          Депонировано: "), _c('b', [_vm._v(_vm._s(_vm.formats.blank(_vm.fileItem.uploaded, _vm.formats.formatDateTime)))]), _vm._v(" (по: " + _vm._s(_vm.formats.blank(_vm.fileItem.deleted, _vm.formats.formatDate)) + ")\n          ")]), _vm._v(" "), _c('v-flex', [_c('span', [_vm._v(" Депонент: "), _c('b', [_vm._v(_vm._s(_vm.fileItem.ownerShortName))]), _vm._v("\n          ИНН: "), _c('b', [_vm._v(_vm._s(_vm.formats.formatInn(_vm.fileItem.ownerInn)))])])]), _vm._v(" "), _c('v-flex', [_vm._v("\n           Файл: "), _c('b', [_vm._v(_vm._s(_vm.fileItem.fileName))])]), _vm._v(" "), _c('v-flex', [_vm._v("\n          Размещение: " + _vm._s(_vm.getDisplayPath(_vm.fileItem.path)) + "\n          ")]), _vm._v(" "), _c('v-flex', [_vm._v("\n          Примечания: " + _vm._s(_vm.fileItem.desc) + "\n          ")]), _vm._v(" "), _c('v-flex', [_vm._v("\n          Теги: "), _c('b', [_vm._v(_vm._s(_vm.fileItem.tags))])]), _vm._v(" "), _c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fileItem.prevUid),
      expression: "fileItem.prevUid"
    }]
  }, [_vm._v("\n            ВАЖНО! Существует\n            "), _c('a', {
    on: {
      "click": function($event) {
        return _vm.openFile(_vm.fileItem.prevUid)
      }
    }
  }, [_vm._v("предыдущая версия файла.")])])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isEdit),
      expression: "isEdit"
    }]
  }, [_c('v-card-title', {
    staticStyle: {
      "display": "block",
      "overflow-wrap": "break-word"
    }
  }, [_c('span', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.fileItem.docName))])]), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-flex', [_c('v-select', {
    attrs: {
      "label": "Размещение в папке",
      "hint": "Структура папок видна только для пользователей депонента",
      "items": _vm.getDisplayPaths(),
      "item-value": "key",
      "item-text": "value"
    },
    model: {
      value: (_vm.fileItem.path),
      callback: function($$v) {
        _vm.$set(_vm.fileItem, "path", $$v)
      },
      expression: "fileItem.path"
    }
  })], 1), _vm._v(" "), _c('v-flex', [_c('v-textarea', {
    attrs: {
      "label": "Примечания",
      "rows": "3",
      "hint": "Примечания видны только для пользователей депонента",
      "clearable": ""
    },
    model: {
      value: (_vm.fileItem.desc),
      callback: function($$v) {
        _vm.$set(_vm.fileItem, "desc", $$v)
      },
      expression: "fileItem.desc"
    }
  })], 1), _vm._v(" "), _c('v-flex', [_c('v-textarea', {
    attrs: {
      "label": "Поисковые теги",
      "hint": "Поисковые теги используются для поиска по документам депонента",
      "rows": "1",
      "clearable": ""
    },
    model: {
      value: (_vm.fileItem.tags),
      callback: function($$v) {
        _vm.$set(_vm.fileItem, "tags", $$v)
      },
      expression: "fileItem.tags"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), (!_vm.isEdit && (_vm.history.length > 1)) ? _c('v-card', [_c('v-panel-title', {
    attrs: {
      "value": _vm.isLoaded,
      "caption": 'Все версии',
      "expandable": true
    },
    on: {
      "click": function($event) {
        _vm.isLoaded = !_vm.isLoaded
      }
    }
  }), _vm._v(" "), _vm._l((_vm.history), function(item) {
    return [_c('v-card', {
      key: item.uid
    }, [(_vm.isLoaded) ? _c('v-card-text', {
      staticStyle: {
        "display": "block",
        "overflow-wrap": "break-word"
      }
    }, [_c('v-flex', [_vm._v("\n        Название: "), _c('b', [_vm._v(_vm._s(item.docName))]), _vm._v(" "), _c(_vm.renderDepoFileSignature(item), {
      tag: "v-component"
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "pl-2": ""
      }
    }, [_c('span', [_vm._v("\n          Депонировано: "), _c('b', [_vm._v(_vm._s(_vm.formats.blank(item.uploaded, _vm.formats.formatDateTime)))]), _vm._v(" (по: " + _vm._s(_vm.formats.blank(item.deleted, _vm.formats.formatDate)) + ")\n          "), _c('v-btn', {
      attrs: {
        "small": "",
        "flat": ""
      },
      on: {
        "click": function($event) {
          return _vm.open(item.uid)
        }
      }
    }, [_vm._v("Открыть")])], 1)])], 1) : _vm._e()], 1)]
  })], 2) : _vm._e()], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44345ea5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/depo/DocForm.vue
// module id = 860
// module chunks = 1